<template>
  <div v-if="!isLoadUsers" class="users__list">
    <div v-for="user in list" :key="user.id" class="users__list-card margin-height__10">
      <Avatar :img="user.avatar" circle="circle" size="xs"></Avatar>
      <div class="users__list-card__info">
        <div class="users__list-card__text">{{ user.name }} {{ user.lastname }}</div>
        <div class="users__list-card__email">{{ user.email }}</div>
      </div>
      <div class="users__list-card__action">
        <Icon class="width-15px pointer" icon="delete" @click="$emit('remove', user)"></Icon>
      </div>
    </div>
  </div>
  <div v-else class="users__list">
    <div v-for="i in 5" :key="i" class="users__list-card margin-height__10">
      <Avatar circle="circle" size="xs"></Avatar>
      <div class="users__list-card__info">
        <div class="users__list-card__text ajax-card__list">
          <p class="ajax__line ajax__line-table-text"></p>
        </div>
        <div class="users__list-card__email ajax-card__list">
          <p class="ajax__line ajax__line-table-text"></p>
        </div>
      </div>
      <div class="users__list-card__action">
        <Icon class="width-15px pointer" icon="delete"></Icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('usersTeamMembers', {
      isLoadUsers: s => s.meta.isLoadUsers
    }),
    list() {
      return this.data.filter(el => !el.isLeader && !el.isCaptian && !el.isDelete);
    }
  }
};
</script>
